import { EventsSharedLayout } from "../events-shared-layout";
import { EventInfo } from "./event-info";

export const EventDetailsPage = () => {
  return (
    <EventsSharedLayout>
      <EventInfo />
    </EventsSharedLayout>
  );
};
